import env from '../env'
import axios from 'axios'

export default class InvoiceApi {
  // 搜索当符合的电子发票列表
  static search (searchData: any) {
    if (searchData.nono !== null) {
      delete searchData.nono
    }
    if (searchData.storeId) {
      delete searchData.storeId
    }
    const data = Object.assign({
    }, searchData)
    return axios.post(env.ORDERMEMBER + '/getOrdersListByMemberWithInvoice', data).then((resp: any) => {
      // hack处理
      // @TODO 订单如果处理对了,在去掉
      // if (resp?.result?.content) {
      //   resp.result.content.forEach(order => {
      //     if (order.invoiceAmount <= 0) {
      //       order.invoiceAmount = order.paidFee + order.invoiceAmount
      //     }
      //   })
      // }
      return resp
    })
  }
  /** 查询当前门店的开通电子发票的信息 */
  static getStoreInvoiceInfo (searchData: any) {
    const data = Object.assign({
    }, searchData)
    return axios.post(env.JMOBILE + '/invoice/getStoreInvoiceConfig', data)
  }
  /** 查询当前品牌有方案列表 */
  static brandInvoiceList (searchData: any) {
    return axios.get(env.INVOICE + '/config/list', { params: searchData })
  }
  /** 会员开票记录 */
  static member (searchData: any) {
    return axios.get(env.INVOICE + '/invoice/member', { params: searchData })
  }
}
